export const DEFAULT_SELECTED_OPTIONS = {
  department: '',
  sub_categories: [],
  size_types: {
    clothes: [],
    waist: [],
    shoes: []
  },
  brands: [],
  store_kind: '',
  price_min: '',
  price_max: '',
  last_published_at: '',
  published_before: '',
  used: null,
  best_sellers: false,
  shipping_range: '',
  sort: '',
  exposure: '',
  plan_id: ''
}

export const AUTO_SELECTED_OPTIONS = {
  shipping_range: () => 'near_regions'
}

export const FILTERS_OPTIONS = {
  department: ['department'],
  sub_categories: ['sub_categories'],
  sizes: ['size_types'],
  brands: ['brands'],
  store_kind: ['store_kind'],
  price: ['price_min', 'price_max'],
  last_published_at: ['last_published_at'],
  published_before: ['published_before'],
  used: ['used'],
  best_sellers: ['best_sellers'],
  shipping_range: ['shipping_range'],
  sort: ['sort'],
  exposure: ['exposure'],
  plan_id: ['plan_id']
}

export const FILTER_SHOULD_BE_NOT_LOWERCASE = ['price', 'sizes', 'store_kind']

export const DEPARTMENTS_WITH_SIZE_FILTER = ['mocas', 'rapazes', 'kids']

export const FILTERS_THAT_REQUIRE_DEPARTMENT = ['sizes', 'sub_categories']

export const FILTERS_BUTTON_DATA_TEST_VALUE = {
  department: {
    button: 'dropdown-departamento',
    reset: 'button-depto-limpar',
    apply: 'button-depto-aplicar'
  },
  sub_categories: {
    button: 'dropdown-categoria',
    reset: 'button-cat-limpar',
    apply: 'button-cat-aplicar'
  },
  brands: {
    button: 'dropdown-marca',
    reset: 'button-marca-limpar',
    apply: 'button-marca-aplicar'
  },
  store_kind: {
    button: 'dropdown-tipo-loja',
    reset: 'button-tipo-loja-limpar',
    apply: 'button-tipo-loja-aplicar'
  },
  sizes: {
    button: 'dropdown-tamanho',
    reset: 'button-tam-limpar',
    apply: 'button-tam-aplicar'
  },
  price: {
    button: 'dropdown-preco',
    reset: 'button-preco-limpar',
    apply: 'button-preco-aplicar'
  },
  last_published_at: {
    button: 'dropdown-novid',
    reset: 'button-novid-limpar',
    apply: 'button-novid-aplicar'
  },
  used: {
    button: 'dropdow-condicao',
    reset: 'button-novo-limpar',
    apply: 'button-novo-aplicar'
  },
  shipping_range: {
    button: 'dropdown-reg-prox',
    reset: 'button-reg-limpar',
    apply: 'button-reg-aplicar'
  },
  sort: {
    button: 'dropdown-mais-revel',
    options: {
      relevants: 'button-mais-relev',
      low_price: 'button-menor-preco',
      high_price: 'button-maior-preco',
      high_discount: 'button-maior-desconto'
    }
  }
}
